import styled from 'styled-components';
import { StockModelCardDealerInfoStyledOV } from './StockModelCardDealerInfoStyled.OV';
import { rem } from 'polished';

export const StockModelCardDealerInfoStyledOVGB = styled(StockModelCardDealerInfoStyledOV)``;
